import {
    Box,
    useColors,
    VerticalStackStretch,
} from "@mallardbay/lib-react-components"
import React from "react"

import COPY from "~config/copy-constants"
import TextControl from "~components/shared/hook-form/controls/text-control"
import {
    RADIO_OPTIONS,
    REQUEST_QUOTE_FORM_KEYS,
} from "~components/shared/request-quote-modal/request-quote-form-helpers"
import HorizontalStackSpaceBetween from "~components/shared/todo-lib-react-components/horizontal-stack-space-between"
import EmailControl from "~components/shared/hook-form/controls/email-control"
import PhoneNumberControl from "~components/shared/hook-form/controls/phone-number-control"
import RadioControl from "~components/shared/hook-form/controls/radio-control"
import TextAreaControl from "~components/shared/hook-form/controls/text-area-control"
import DateControl from "~components/shared/hook-form/controls/date-control"
import FormLabel from "~components/shared/todo-lib-react-components/form-label"
import ListingSelectControl from "~components/shared/hook-form/controls/listing-select-control"

const { REQUEST_QUOTE_FORM_LABELS } = COPY

interface Props {
    readonly outfitterId: string
}

export default function RequestQuoteInputs({ outfitterId }: Props) {
    const styles = useStyles()

    return (
        <VerticalStackStretch style={styles.vStack}>
            <HorizontalStackSpaceBetween>
                <TextControl
                    name={REQUEST_QUOTE_FORM_KEYS.FIRST_NAME}
                    label={REQUEST_QUOTE_FORM_LABELS.FIRST_NAME}
                    isRequired
                />
                <TextControl
                    name={REQUEST_QUOTE_FORM_KEYS.LAST_NAME}
                    label={REQUEST_QUOTE_FORM_LABELS.LAST_NAME}
                    isRequired
                />
            </HorizontalStackSpaceBetween>
            <EmailControl
                name={REQUEST_QUOTE_FORM_KEYS.EMAIL}
                label={REQUEST_QUOTE_FORM_LABELS.EMAIL}
                isRequired
            />
            <PhoneNumberControl
                name={REQUEST_QUOTE_FORM_KEYS.PHONE}
                label={REQUEST_QUOTE_FORM_LABELS.PHONE}
            />
            <RadioControl
                name={REQUEST_QUOTE_FORM_KEYS.PREFERRED_CONTACT}
                label={REQUEST_QUOTE_FORM_LABELS.PREFERRED_CONTACT}
                options={RADIO_OPTIONS}
                isVertical={false}
                isRequired
            />
            <ListingSelectControl
                name={REQUEST_QUOTE_FORM_KEYS.LISTING_ID}
                label={REQUEST_QUOTE_FORM_LABELS.LISTING}
                outfitterId={outfitterId}
            />
            <Box>
                <FormLabel isRequired>
                    {REQUEST_QUOTE_FORM_LABELS.PREFERRED_DATES}
                </FormLabel>
                <HorizontalStackSpaceBetween>
                    <DateControl
                        name={REQUEST_QUOTE_FORM_KEYS.PREFERRED_START_DATE}
                        label={REQUEST_QUOTE_FORM_LABELS.FROM}
                        placeholder={REQUEST_QUOTE_FORM_LABELS.SELECT_FROM_DATE}
                    />
                    <DateControl
                        name={REQUEST_QUOTE_FORM_KEYS.PREFERRED_END_DATE}
                        label={REQUEST_QUOTE_FORM_LABELS.TO}
                        placeholder={REQUEST_QUOTE_FORM_LABELS.SELECT_TO_DATE}
                    />
                </HorizontalStackSpaceBetween>
            </Box>
            <TextAreaControl
                name={REQUEST_QUOTE_FORM_KEYS.TRIP_DETAILS}
                label={REQUEST_QUOTE_FORM_LABELS.TRIP_DETAILS}
                isRequired
            />
        </VerticalStackStretch>
    )
}

function useStyles() {
    const colors = useColors()
    return {
        vStack: {
            gap: 6,
        },
        listingCard: {
            backgroundColor: colors.modalBackground,
        },
    }
}
